define 'controller/BackToTheTopController', ['jquery'], ($) ->
  class BackToTheTopController

    constructor: (@$el) ->
      @$self = @$el
      @_init()


    _init: ->
      el = @$self
      $(window).on 'scroll' , ->
        height = $(window).scrollTop()
        if (height > 100)
          el.show
        else
          el.hide

      @$self.on 'click', this._onClick

    _onClick: ->
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0